module.exports = __webpack_public_path__ + "img/JMD.40693cba.svg";